<template>
  <div id="regular-alerts">
    <HeroSection :size="size" :theme="theme">
      <div class="row justify-content-lg-between align-items-lg-center pb-2 mb-5">
        <div class="col-lg-6 mb-lg-0 pb-0 px-3">
          <h1 class="font-size-4 text-navy">Monthly, weekly or daily alerts on the best deals</h1>
          <p class="h3 mt-3 mb-4 text-black-70">
            Our MortgageWatch service will send you regular updates* on market-leading mortgage deals that could <span class="text-warning">save you thousands</span> each year on your mortgage payments.
          </p>
          <p class="text-black-70">
            * Don't worry, it's up to you how often you hear from us - just login to your account to control the frequency of alerts.
          </p>
        </div>
        <div class="col-lg-6 dd-none d-lg-inline-block text-center">
          <figure>
            <img class="js-svg-injector img-fluid w-lg-90 w-sm-60" src="/assets/svg/illustrations/calendar.svg" alt="Image Description">
          </figure>
        </div>
      </div>
    </HeroSection>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "RegularAlerts",
  components: {HeroSection},
  
  props: {
    theme: {
      type: String,
      default: "home/regular-alerts"
    },
    size: {
      type: String,
      default: "md"
    }
  }
};
</script>
